import { FunctionComponent, h, JSX } from 'preact';
import { useCallback } from 'preact/hooks';
import { useTheme } from '../../../hooks/use-theme/use-theme';

interface Props {
	onChange: (approveTermsAndConditions: boolean) => void;
	isChecked: boolean;
	isDisabled: boolean;
	termsAndConditionsText: string;
	className?: string;
}

const ApproveTermsAndConditions: FunctionComponent<Props> = ({
	onChange,
	isChecked,
	isDisabled,
	termsAndConditionsText,
	className
}) => {
	const { primaryColor } = useTheme();

	const getApproveTermsAndConditionsText = () => {
		// Example: Please click [here](https://www.bringg.com/terms-of-service/) to view the terms and conditions
		const markdownLinkRegex = '\\[([^\\]]*)\\]\\(([^\\s^\\)]*)\\)';

		const linkMatch = termsAndConditionsText.match(markdownLinkRegex);

		if (!linkMatch) {
			return <span data-testid="terms-and-conditions-span">{termsAndConditionsText}</span>;
		}

		const beforeMatchString = termsAndConditionsText.substring(0, linkMatch.index);
		const afterMatchString = termsAndConditionsText.substring(linkMatch.index + linkMatch[0].length);
		const linkText = linkMatch[1];
		const linkUrl = linkMatch[2];

		return (
			<span className="terms-and-conditions-span" data-testid="terms-and-conditions-span">
				{beforeMatchString}
				<a data-testid="terms-and-conditions-link" href={linkUrl} target="_blank" rel="noreferrer noopener">
					{linkText}
				</a>
				{afterMatchString}
			</span>
		);
	};

	const handleOnChange = useCallback(
		(event: JSX.TargetedEvent<HTMLInputElement, Event>) => {
			const { target } = event;
			onChange((target as HTMLInputElement).checked);
		},
		[onChange]
	);

	return (
		<div className={className}>
			<label className="checkbox-text-container">
				<input
					type="checkbox"
					className="optin-checkbox"
					disabled={isDisabled}
					style={{ accentColor: primaryColor }}
					checked={isChecked}
					data-testid="terms-and-conditions"
					onChange={handleOnChange}
				/>
				{getApproveTermsAndConditionsText()}
			</label>
		</div>
	);
};

export default ApproveTermsAndConditions;
